/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Card, ICardProps } from "../../Card";

export interface IFieldCardProps extends ICardProps {
	className?: string;
}

export const FieldCard: React.FC<IFieldCardProps> = ({ className, children, ...props }) => {
	const baseClass = BEM("edt-field-card");

	if (className) {
		baseClass.add(className);
	}

	return (
		<Card className={baseClass.toClassName()} {...props}>
			{children}
		</Card>
	);
};
